// Local queue for Kiosk walk-in check-ins created while the gate has no internet
// connection. Each queued job bundles everything collected during the wizard
// (visitor form, photo/ID as base64, briefing signatures) so the whole check-in
// can be replayed against the real API once connectivity returns. Persisted in
// localStorage so a queued check-in survives a tab reload.
const QUEUE_KEY = "offline_checkin_queue";

export function getQueue() {
  try {
    return JSON.parse(localStorage.getItem(QUEUE_KEY)) || [];
  } catch {
    return [];
  }
}

function saveQueue(queue) {
  localStorage.setItem(QUEUE_KEY, JSON.stringify(queue));
}

export function enqueue(job) {
  const local_id = `offline_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
  const full = { local_id, status: "pending", created_at: new Date().toISOString(), ...job };
  const queue = getQueue();
  queue.push(full);
  saveQueue(queue);
  return local_id;
}

export function updateJob(local_id, patch) {
  saveQueue(getQueue().map((j) => (j.local_id === local_id ? { ...j, ...patch } : j)));
}

export function removeJob(local_id) {
  saveQueue(getQueue().filter((j) => j.local_id !== local_id));
}

export function getPendingCount() {
  return getQueue().length;
}
